import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const Visa = ({ size, className, id }) => {
  let ratio = size / 100;

  let width = size,
    height = 63 * ratio;

  let _attributes = {
    width: width || 100,
    height: height || 63,
    viewBox: "0 0 100 63"
  };

  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(className);
  }

  return (
    <svg {..._attributes}>
      <g transform="translate(-1011.5 -618.5)">
        <rect width="100" height="63" transform="translate(1011.5 618.5)" fill="none" />
        <g transform="translate(1023.472 638.923)">
          <g transform="translate(0 0)">
            <path d="M59.523,76.466H53.2l3.951-24.28h6.321Z" transform="translate(-25.941 -51.752)" fill="#004c9b" />
            <path d="M33.17,52.187l-6.027,16.7-.712-3.6h0L24.3,54.374s-.257-2.187-3-2.187H11.343l-.116.41a23.614,23.614,0,0,1,6.611,2.776L23.33,76.466h6.586L39.973,52.187Z" transform="translate(-11.227 -51.753)" fill="#004c9b" />
            <path d="M112.564,76.466h5.8l-5.061-24.279h-5.082A2.9,2.9,0,0,0,105.307,54l-9.426,22.47h6.588l1.318-3.606h8.036Zm-6.956-8.588,3.322-9.086,1.868,9.086Z" transform="translate(-40.902 -51.753)" fill="#004c9b" />
            <path d="M86.928,57.791l.9-5.214a18.245,18.245,0,0,0-5.685-1.059c-3.137,0-10.585,1.372-10.585,8.038,0,6.273,8.742,6.351,8.742,9.644s-7.842,2.7-10.429.627l-.94,5.451a17.7,17.7,0,0,0,7.136,1.372c4.313,0,10.821-2.235,10.821-8.312,0-6.313-8.822-6.9-8.822-9.644S84.223,56.3,86.928,57.791Z" transform="translate(-31.455 -51.518)" fill="#004c9b" />
          </g>
          <path d="M26.431,65.291,24.3,54.374s-.257-2.187-3-2.187H11.343l-.116.41a24.507,24.507,0,0,1,9.382,4.71A18.936,18.936,0,0,1,26.431,65.291Z" transform="translate(-11.227 -51.753)" fill="#f99410" />
        </g>
      </g>
    </svg>
  );
};

Visa.defaultProps = {
  size: 100,
  className: "",
  id: ""
};

Visa.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
